import axios from 'axios';
import store from './store';

import { stringify } from 'query-string';
import {calculationPayload} from "./calculation/calculationData";

const base = process.env.VUE_APP_IDENTITY_HOST;
const datahub = process.env.VUE_APP_DATAHUB_URL;

const cachedCalculationURL = process.env.VUE_APP_DATAHUB_URL + "tarifierung";
const tokenPURL = base + process.env.VUE_APP_IDENTITY_PATH;

axios.interceptors.request.use(function (config) {

    const auth = store.getters["authToken"];
    if (auth && config.url != cachedCalculationURL && config.url != tokenPURL) {
        config.headers.Authorization = `Bearer ${auth.access_token}`
    }

    return config;
});

// Retrieves base Calculation Data
export const calculationSettings = () => {
    return axios.get( datahub+ "calculation");
}

// Retrieves an anon Token for calculation
export const getToken = () => {
    const username = process.env.VUE_APP_ANON_USERNAME;
    const password = process.env.VUE_APP_ANON_PASSWORD;

    return axios.post(tokenPURL, stringify({
        username,
        password,
        grant_type: 'password',
        scope: 'api ideal-endkunden-data offline_access'

    }), {

        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: 'Basic aWRlYWwtZW5ka3VuZGVuLWFwcDppZGVhbC5lbmRrdW5kZQ=='
        }
    });
}

/**
 * Liefert ein gebuffertes Berechnungsergebnis
 * @returns {Promise<AxiosResponse<T>>}
 */
export const getCalculationFromBuffer = () => {
    return axios.get(cachedCalculationURL);
}
/**
* Executes a calculation
 */
export const Tarifierung = (params) => {
    return axios.post(process.env.VUE_APP_API_PATH + "/tarifierung", calculationPayload(params));
}

/*
    Returns the calculation table
 */
export const Kontensicht = () => {
    const iposnummer = store.getters["iposnummer"];
    return axios.get(process.env.VUE_APP_API_PATH + "/kontensicht/" + iposnummer + "/rente/5-jaehrlich");
}

